// TX-Limit-Helper.
// Tracking ist für ALLE Tarife unbegrenzt (TIER_LIMITS = Infinity, Stand 2026-06-03);
// diese Helper bleiben für künftiges Output-Gating (Report-Umfang) nutzbar und
// werden mit Infinity-Limit automatisch zur No-Op.
// Pro Tarif siehe TIER_LIMITS in UserPlanContext.

/** Extrahiert das Jahr aus einer TX. tx.datum kann 'YYYY-MM-DD' oder Date sein. */
export function getTxYear(tx) {
  if (!tx) return null;
  const d = tx.datum;
  if (!d) return null;
  if (typeof d === 'string') {
    // 'YYYY-MM-DD' oder 'DD.MM.YYYY' tolerieren
    const ymd = d.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (ymd) return Number(ymd[1]);
    const dmy = d.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (dmy) return Number(dmy[3]);
    const parsed = new Date(d);
    if (!Number.isNaN(parsed.getTime())) return parsed.getFullYear();
    return null;
  }
  if (d instanceof Date) return d.getFullYear();
  if (typeof d?.toDate === 'function') return d.toDate().getFullYear(); // Firestore Timestamp
  return null;
}

/** Zählt alle TX im angegebenen Jahr. */
export function countTxsInYear(txs, year) {
  if (!Array.isArray(txs) || !year) return 0;
  let n = 0;
  for (const tx of txs) {
    if (getTxYear(tx) === year) n++;
  }
  return n;
}

/** Aktuelles Steuerjahr (Kalenderjahr DE). */
export function getCurrentTaxYear() {
  return new Date().getFullYear();
}

/**
 * Liefert {count, limit, remaining, atLimit, nearLimit, year} für das laufende Jahr.
 * nearLimit: ab 80% des Limits → UI kann "fast voll" anzeigen.
 */
export function getYearUsage(txs, txYearLimit, year = getCurrentTaxYear()) {
  const limit = Number.isFinite(txYearLimit) ? txYearLimit : Infinity;
  const count = countTxsInYear(txs, year);
  const remaining = limit - count;
  return {
    year,
    count,
    limit,
    remaining,
    atLimit: remaining <= 0 && Number.isFinite(limit),
    nearLimit: Number.isFinite(limit) && count >= limit * 0.8,
  };
}

/**
 * Würde ein TX-Batch das Limit überschreiten?
 * @returns {{ ok: true } | { ok: false, wouldExceedBy: number, year: number, count: number, limit: number }}
 */
export function checkBatchAgainstLimit(txs, newBatch, txYearLimit) {
  if (!Number.isFinite(txYearLimit)) return { ok: true };
  const year = getCurrentTaxYear();
  const existingCount = countTxsInYear(txs, year);
  // Wir zählen nur neue TX im aktuellen Jahr — TX aus früheren Jahren belasten das
  // laufende Limit nicht (jedes Steuerjahr hat sein eigenes Konto).
  const newInYear = (newBatch || []).filter(tx => getTxYear(tx) === year).length;
  const total = existingCount + newInYear;
  if (total <= txYearLimit) return { ok: true };
  return {
    ok: false,
    wouldExceedBy: total - txYearLimit,
    year,
    count: existingCount,
    limit: txYearLimit,
    newInYear,
  };
}
